export default "__VITE_ASSET__4buAUeUB__"